import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=34fea724"
import script from "./termsofuse.vue?vue&type=script&lang=js"
export * from "./termsofuse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports